import React, { Component } from 'react'

export default class SummaryPlaceholder extends Component {
  render () {
    return (
      <div className='checkout-side col-12 col-lg-4 mb-3 mb-sm-0 mt-2 mt-lg-0 px-0 py-0'>
        <div className='col-12 border-ui-3 radius bg-white px-0 py-0'>
          <div className='col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
            <h2 className='color-title txt-font-body'>Resumo do pedido</h2>
          </div>
          <div className='col-12 mx-0'>
            <div className='row px-3 pb-2 pt-2 bg-ui-5 d-flex justify-content-start'>
              <div className='col-3 px-2 radius bg-ui-3 pt-1' />
            </div>
            <div className='row px-3 pb-2 pt-2 bg-ui-5 d-flex justify-content-start'>
              <div className='col-12 px-2 radius bg-ui-3 pt-1' />
            </div>
            <div className='row px-3 pb-2 pt-2 bg-ui-5 d-flex justify-content-start'>
              <div className='col-5 px-2 radius bg-ui-3 pt-1' />
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Checkout/Summary/SummaryPlaceholder.js